import { c as _c } from "react/compiler-runtime";
import NFTLeaderboard from "@/components/leaderboard/NFTLeaderboard";
import { NftPageStats } from "@/components/nft-attributes/NftStats";
import type { NFT } from "@/entities/INFT";
import { numberWithCommas, printMintDate } from "@/helpers/Helpers";
import { Col, Container, Row, Table } from "react-bootstrap";
import styles from "./TheMemes.module.scss";
export function MemePageCollectorsRightMenu(props) {
  const $ = _c(37);
  if (props.show && props.nft) {
    let t0;
    let t1;
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = {
        span: 12
      };
      t1 = {
        span: 12
      };
      t2 = {
        span: 6
      };
      t3 = {
        span: 6
      };
      $[0] = t0;
      $[1] = t1;
      $[2] = t2;
      $[3] = t3;
    } else {
      t0 = $[0];
      t1 = $[1];
      t2 = $[2];
      t3 = $[3];
    }
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <Row><Col><h3>NFT</h3></Col></Row>;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <td>Mint Date</td>;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    let t6;
    if ($[6] !== props.nft.mint_date) {
      t6 = printMintDate(props.nft.mint_date);
      $[6] = props.nft.mint_date;
      $[7] = t6;
    } else {
      t6 = $[7];
    }
    let t7;
    if ($[8] !== t6) {
      t7 = <tr>{t5}<td>{t6}</td></tr>;
      $[8] = t6;
      $[9] = t7;
    } else {
      t7 = $[9];
    }
    let t8;
    if ($[10] !== props.nft) {
      t8 = <NftPageStats nft={props.nft} />;
      $[10] = props.nft;
      $[11] = t8;
    } else {
      t8 = $[11];
    }
    let t9;
    if ($[12] !== t7 || $[13] !== t8) {
      t9 = <Table bordered={false} className={styles.hodlersTable}><tbody>{t7}{t8}</tbody></Table>;
      $[12] = t7;
      $[13] = t8;
      $[14] = t9;
    } else {
      t9 = $[14];
    }
    let t10;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <Row className="pt-2"><Col><h3>TDH</h3></Col></Row>;
      $[15] = t10;
    } else {
      t10 = $[15];
    }
    let t11;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <td>TDH</td>;
      $[16] = t11;
    } else {
      t11 = $[16];
    }
    const t12 = Math.round(props.nft.boosted_tdh * 100) / 100;
    let t13;
    if ($[17] !== t12) {
      t13 = numberWithCommas(t12);
      $[17] = t12;
      $[18] = t13;
    } else {
      t13 = $[18];
    }
    let t14;
    if ($[19] !== t13) {
      t14 = <tr>{t11}<td>{t13}</td></tr>;
      $[19] = t13;
      $[20] = t14;
    } else {
      t14 = $[20];
    }
    let t15;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = <td>Unweighted TDH</td>;
      $[21] = t15;
    } else {
      t15 = $[21];
    }
    const t16 = Math.round(props.nft.tdh__raw * 100) / 100;
    let t17;
    if ($[22] !== t16) {
      t17 = numberWithCommas(t16);
      $[22] = t16;
      $[23] = t17;
    } else {
      t17 = $[23];
    }
    let t18;
    if ($[24] !== t17) {
      t18 = <tr>{t15}<td>{t17}</td></tr>;
      $[24] = t17;
      $[25] = t18;
    } else {
      t18 = $[25];
    }
    let t19;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
      t19 = <td>Meme Rank</td>;
      $[26] = t19;
    } else {
      t19 = $[26];
    }
    const t20 = props.nft.tdh_rank ? `#${props.nft.tdh_rank}` : "-";
    let t21;
    if ($[27] !== t20) {
      t21 = <tr>{t19}<td>{t20}</td></tr>;
      $[27] = t20;
      $[28] = t21;
    } else {
      t21 = $[28];
    }
    let t22;
    if ($[29] !== t14 || $[30] !== t18 || $[31] !== t21) {
      t22 = <Table bordered={false} className={styles.hodlersTable}><tbody>{t14}{t18}{t21}</tbody></Table>;
      $[29] = t14;
      $[30] = t18;
      $[31] = t21;
      $[32] = t22;
    } else {
      t22 = $[32];
    }
    let t23;
    if ($[33] !== t22 || $[34] !== t9) {
      t23 = <Col xs={t0} sm={t1} md={t2} lg={t3} className="pt-2"><Container className="p-0">{t4}<Row><Col>{t9}{t10}{t22}</Col></Row></Container></Col>;
      $[33] = t22;
      $[34] = t9;
      $[35] = t23;
    } else {
      t23 = $[35];
    }
    return t23;
  } else {
    let t0;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <></>;
      $[36] = t0;
    } else {
      t0 = $[36];
    }
    return t0;
  }
}
export function MemePageCollectorsSubMenu(props) {
  const $ = _c(4);
  if (props.show && props.nft) {
    let t0;
    if ($[0] !== props.nft.contract || $[1] !== props.nft.id) {
      t0 = <Row className="pt-3"><Col><NFTLeaderboard contract={props.nft.contract} nftId={props.nft.id} /></Col></Row>;
      $[0] = props.nft.contract;
      $[1] = props.nft.id;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    return t0;
  } else {
    let t0;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <></>;
      $[3] = t0;
    } else {
      t0 = $[3];
    }
    return t0;
  }
}